<template>
  <b-card header-tag="header" class="apply-box">

    <b-form autocomplete="off" method="POST" @submit.prevent="submit">
      <b-row>
        <b-col cols="12" md="6">
          <b-form-group label="Job:" label-for="job" v-if="jobSearch">
            <multiselect class="multiselect-rlnx" v-model="selectedJob" label="title" track-by="id" placeholder="Type to search" open-direction="bottom" :options="jobSearch"
            :searchable="true" :loading="$apollo.queries.jobSearch.loading" :limit="3" :max-height="600"
            @search-change="value => jobSearchQuery = value" :class="{ 'is-invalid': typeof isValid.selectedJob === 'string' }">
              <template v-slot:option="{ option }">
                {{ option.title }}
                <template v-if="option.atsID">({{ option.atsID }}) </template>
                <template v-if="option.location && option.location.name">({{ option.location.name }}) </template>
                <template v-if="option.status !== 'ACTIVE'">({{ option.status }}) </template>
              </template>
              <template v-slot:noResult>No jobs found - consider changing your search query</template>
            </multiselect>
            <div class="invalid-feedback" style="display: inherit" v-if="isValid.selectedJob === 'NOT_SELECTED'">
              You must select a job
            </div>
          </b-form-group>
        </b-col>

        <b-col cols="12" md="6">
          <b-form-group label="Referee (optional):" label-for="user" v-if="allUsers">
            <multiselect v-model="selectedUser" :options="allUsers" placeholder="Select one or leave blank" label="fullName" track-by="id" class="multiselect-rlnx">
              <template v-slot:noResult>Not found - has the employee signed up to the platform yet?</template>
            </multiselect>
          </b-form-group>
        </b-col>

        <div class="w-100"/>

        <b-col cols="12" md="6">
          <b-form-group label="Name:" label-for="formName">
            <b-form-input id="formName" type="text" required placeholder="Name" v-model="form.fullName" :class="{ 'is-invalid': typeof isValid.fullName === 'string' }" />
            <div class="invalid-feedback" v-if="isValid.fullName === 'TOO_SHORT'">
              Name is too short
            </div>
            <div class="invalid-feedback" v-if="isValid.fullName === 'EMPTY'">
              Please enter a first name
            </div>
          </b-form-group>
        </b-col>

        <b-col cols="12" md="6">
          <b-form-group label="Email address:" label-for="emailAddress">
            <b-form-input id="emailAddress" type="email" required placeholder="Enter email" v-model="form.emailAddress" :class="{ 'is-invalid': typeof isValid.emailAddress === 'string' }" />
            <div class="invalid-feedback" v-if="isValid.emailAddress === 'TOO_SHORT'">
              Email address is too short
            </div>
            <div class="invalid-feedback" v-if="isValid.emailAddress === 'MISSING_AT'">
              Please enter a valid email address
            </div>
          </b-form-group>
        </b-col>

        <b-col cols="12" md="6">
          <b-form-group label="Phone Number:" label-for="formLastName">
            <b-form-input id="formPhone" type="text"  placeholder="phone number" v-model="form.phoneNumber" />
          </b-form-group>
        </b-col>

        <div class="w-100"/>

        <b-col cols="12" md="6">
          <b-form-group label="Resume" label-for="formResume" v-if="typeof applyWithResume === 'boolean'">
            <b-form-file class="form-control border-0" id="formResume" :required="applyWithResume === true" v-model="form.resume"
              accept=".txt,.rtf,.pdf,.doc,.docx,.odt" placeholder="No resume selected" @change="e => uploadFile('resume', e)"
              :class="{ 'is-invalid': typeof isValid.resume === 'string' }"/>
            <div class="invalid-feedback" v-if="isValid.resume === 'MISSING_FILE'">
              Please select a file to upload
            </div>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="6">
          <b-form-group label="Cover Letter" label-for="formCoverLetter" v-if="typeof applyWithCoverLetter === 'boolean'">
            <b-form-file class="form-control border-0" id="formResume" :required="applyWithCoverLetter === true" v-model="form.coverLetter"
              accept=".txt,.rtf,.pdf,.doc,.docx,.odt" placeholder="No cover letter selected" @change="e => uploadFile('coverLetter', e)"
              :class="{ 'is-invalid': typeof isValid.coverLetter === 'string' }"/>
            <div class="invalid-feedback" v-if="isValid.coverLetter === 'MISSING_FILE'">
              Please select a file to upload
            </div>
          </b-form-group>
        </b-col>

        <div class="w-100"/>

        <b-col cols="12" md="6">
          <b-form-group>
            <b-form-checkbox id="terms" required v-model="form.termsAgreed" :class="{ 'is-invalid': form.termsAgreed }">
              Agreed to the <a href="#">terms &amp; conditions</a>
            </b-form-checkbox>

            <div class="invalid-feedback" style="display: inherit" v-if="form.termsAgreed === false" >
              You must agree to the terms and conditions.
            </div>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-button type="submit" variant="primary" @click.prevent="submit"><template>Submit</template></b-button>
      </b-row>
    </b-form>

    <b-row>
      <b-col cols="12" v-if="applied">
        <h3 class="text-center pt-3">Application Added Successfully 👍</h3>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import assetUploadMixin from '@/mixins/assetUpload';
import UsersIndexQuery from '@/graphql/queries/UsersList.gql';
import JobSearchQuery from '@/graphql/queries/JobSearch.gql';
import ms from 'ms';
import Multiselect from 'vue-multiselect';
import { mapRoot, mapPreferences } from '@src/mixins/root';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { createSha1File } from '@/lib/hashing';

export default {
  name: 'Apply-Recruiter',
  components: {
    FontAwesomeIcon,
    Multiselect
  },
  mixins: [ assetUploadMixin ],
  data: () => ({
    applied: false,
    form: {},
    err: null,
    allUsers: null,
    jobSearchQuery: null,
    selectedUser: null,
    selectedJob: null,
  }),
  props: {
    applicationsArray: Array,
  },
  apollo: {
    allUsers: {
      query: UsersIndexQuery,
      update: ({ company: { userConnections } }) => (userConnections.edges || []).map(({ entry }) => entry),
      error(err) {
        this.err = `${err}`;
      },
    },
    jobSearch: {
      query: JobSearchQuery,
      variables() {
        const { jobSearchQuery } = this;
        return { limit: 10, where: { title: jobSearchQuery } };
      },
      debounce: ms('1s'),
      update: ({ company: { jobs } }) => jobs,
      error(err) {
        this.err = `${err}`;
      },
    },
  },
  computed: {
    ...mapRoot([ 'isRecruiter' ]),
    ...mapPreferences([ 'applyWithResume', 'applyWithCoverLetter' ]),
    isValid() {
      const isValid = {};

      if (this.form.hasOwnProperty('fullName')) {
        const { fullName } = this.form;

        if (fullName.length < 2) {
          isValid.fullName = 'TOO_SHORT';
        } else if (!fullName) {
          isValid.fullName = 'EMPTY';
        } else {
          isValid.fullName = true;
        }
      } else {
        isValid.fullName = null;
      }

      if (this.form.hasOwnProperty('emailAddress')) {
        const { emailAddress } = this.form;

        if (emailAddress && emailAddress.length < 3) {
          isValid.emailAddress = 'TOO_SHORT';
        } else if (emailAddress && !emailAddress.includes('@')) {
          isValid.emailAddress = 'MISSING_AT';
        } else {
          isValid.emailAddress = true;
        }
      } else {
        isValid.emailAddress = null;
      }

      if (this.form.hasOwnProperty('resume')) {
        const { resume } = this.form;
        if (resume && resume.id) {
          isValid.resume = true;
        } else if (this.applyWithResume === true) {
          isValid.resume = 'MISSING_FILE';
        }
      }

      if (this.form.hasOwnProperty('coverLetter')) {
        const { coverLetter } = this.form;
        if (coverLetter && coverLetter.id) {
          isValid.coverLetter = true;
        } else if (this.applyWithCoverLetter === true) {
          isValid.coverLetter = 'MISSING_FILE';
        }
      }

      if (this.form.hasOwnProperty('termsAgreed')) {
        isValid.termsAgreed = this.form.termsAgreed === true;
      } else {
        isValid.termsAgreed = null;
      }

      if (this.form.hasOwnProperty('jobID')) {
        if (this.selectedJob) {
          isValid.selectedJob = true;
        } else if (!this.selectedJob) {
          isValid.selectedJob = 'NOT_SELECTED';
        } else {
          isValid.selectedJob = null;
        }
      } else {
        isValid.selectedJob = null;
      }

      return isValid;
    },
  },
  methods: {
    async uploadFile(field, event) {
      try {
        this.$assert(event.target.files && event.target.files.length, new Error('Expected a file to be selected'));

        const [ file ] = event.target.files;
        this.$assert(file && file.name, new Error('No file was selected'), {
          code: 'FILE_NOT_FOUND',
        });

        const { token, asset: uploading, upload } = await this.createAssetMutation({
          type: 'DOCUMENT',
          fileName: file.name,
          fileMime: file.type,
          fileSize: file.size,
          fileSha1: await createSha1File(file),
        });

        this.$log.debug({ file: file.name, uploading, upload });

        await this.initAssetUpload(upload, file);

        const asset = await this.uploadedAssetMutation(token);
        this.$assert(asset && asset.id, new Error('Failed to upload file'));
        this.form[field] = { id: asset.id };
      } catch (err) {
        this.$log.error(err);
        this.$notifyErr(err);
      }
    },
    submit() {
      console.log(this.form);
      this.form = Object.assign({
        fullName: '',
        emailAddress: '',
        phoneNumber: '',
        resume: null,
        coverLetter: null,
        termsAgreed: false,
      }, this.form, {
        userID: this.selectedUser ? this.selectedUser.id : null,
        jobID: this.selectedJob ? this.selectedJob.id : null,
      });

      const isValid = Object.keys(this.isValid).reduce((result, key) => result && this.isValid[key] === true, true);

      if (isValid) {
        this.applied = true;
        this.$emit('submit', this.form);
      }
    }
  },
};
</script>

<style lang="scss">
@import './../../scss/variables';

.apply-box {

  form {
    padding: 1rem;
    width: 100%;
  }

  .btn {
    margin: 0 auto;
  }
  .btn-primary {
    margin-top: 1em;
    width: 100%;
  }

}
</style>



// WEBPACK FOOTER //
// src/components/jobs/applyHr.vue